import React from 'react'

const Title = (props) => {
  const sizeClass = props.size ? `title--size-${props.size}` : '';
  const alignClass = props.align ? `title--align-${props.align}` : '';
  const customClass = props.customClass ? `${props.customClass}` : '';
  const id = props.id ? props.id : '';
  let classes = `title ${sizeClass} ${alignClass} ${customClass}`.trim();
  let Component;

  switch(props.level){
    case '1': Component = <h1 className={classes} id={id}>{props.children}</h1>; break;
    case '2': Component = <h2 className={classes} id={id}>{props.children}</h2>; break;
    case '3': Component = <h3 className={classes} id={id}>{props.children}</h3>; break;
    default: Component = <div className={classes} id={id}>{props.children}</div>; break;
  }
  return Component;
}

export default Title